"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import LogoBlue from "../../../public/images/logo_white.png";
import Logo from "../../../public/images/logo_blue.png";
import { usePathname } from "next/navigation";
import { useHeroStore } from "../../stores/useHeroStore";
import { handleStart } from "../home/utils/helper";

const Navbar = () => {
  const pathname = usePathname();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const setClickCount = useHeroStore((state) => state.setClickCount);
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu when path changes
  // useEffect(() => {
  //   setMobileMenuOpen(false);
  // }, [pathname]);
  // lg:max-w-[calc(100vw-30px)] xxl:
  return (
    <nav
      aria-label="Primary navigation"
      className={`mt-0 transition-all duration-200 ease-in-out py-4.5 md:py-5 px-5 lg:rounded-[10px] mx-auto w-full max-w-360 ${
        isScrolled || mobileMenuOpen
          ? "bg-white fixed left-0 right-0 top-0 z-200 mt-0 lg:mt-5"
          : ""
      }`}
      style={
        isScrolled
          ? { boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.14)" }
          : mobileMenuOpen
            ? { boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.05)" }
            : {}
      }
    >
      <div className="flex items-center">
        <div className="flex justify-between items-center w-full">
          {/* Desktop Menu */}
          <div className="flex gap-[60px]">
            <div className="flex items-center gap-10">
              <Link href="/">
                {isScrolled ? (
                  <Image
                    src={LogoBlue}
                    alt="logo"
                    className="w-[150px] h-[30px]"
                  />
                ) : (
                  <Image src={Logo} alt="logo" className="w-[150px] h-[30px]" />
                )}
              </Link>
            </div>

            <div className="hidden lg:flex items-center gap-[5px] ">
              <button
                onClick={() => setClickCount(1)}
                className={`cursor-pointer text-[16px] font-semibold py-2.5 px-3 transition-all duration-300 ease-in-out ${isScrolled ? "text-[#04082C]" : "text-white"} hover:text-[#7D7D7D]  font-openSans  ${
                  pathname === "/pricings" ? "text-ti_grey" : ""
                }`}
              >
                Origin stamp
              </button>
              <button
                onClick={() => setClickCount(2)}
                className={`cursor-pointer text-[16px] font-semibold py-2.5 px-3 transition-all duration-300 ease-in-out ${isScrolled ? "text-[#04082C]" : "text-white"} hover:text-[#7D7D7D]  font-openSans  ${
                  pathname === "/pricings" ? "text-ti_grey" : ""
                }`}
              >
                Impact stamp
              </button>
              <button
                onClick={() => setClickCount(3)}
                className={`cursor-pointer text-[16px] font-semibold py-2.5 px-3 transition-all duration-300 ease-in-out ${isScrolled ? "text-[#04082C]" : "text-white"} hover:text-[#7D7D7D]  font-openSans  ${
                  pathname === "/pricings" ? "text-ti_grey" : ""
                }`}
              >
                Invoice stamp
              </button>
              {/* <Link
                href="/"
                className={`cursor-pointer text-[16px] font-semibold py-2.5 px-3 transition-all duration-300 ease-in-out ${isScrolled ? "text-[#04082C]" : "text-white"} hover:text-[#7D7D7D]  font-openSans  ${
                  pathname === "/pricings" ? "text-ti_grey" : ""
                }`}
              >
                Our mission
              </Link> */}
            </div>
          </div>
          <button
            onClick={handleStart}
            className="submit-button cursor-pointer"
          >
            Start a drive
          </button>
          {/* Desktop Menu end */}

          {/* Mobile Menu Button */}
          {/* <button
            className="lg:hidden flex items-center justify-center z-1001"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <AnimatePresence mode="wait">
              {mobileMenuOpen ? (
                <motion.div
                  aria-label="close menu"
                  key="close"
                  initial={{ rotate: -90, opacity: 0 }}
                  animate={{ rotate: 0, opacity: 1 }}
                  exit={{ rotate: 90, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <X size={24} className="text-[#04082C]" />
                </motion.div>
              ) : (
                <motion.div
                  aria-label="open menu"
                  key="menu"
                  initial={{ rotate: 90, opacity: 0 }}
                  animate={{ rotate: 0, opacity: 1 }}
                  exit={{ rotate: -90, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <Menu size={24} className="text-[#04082C]" />
                </motion.div>
              )}
            </AnimatePresence>
          </button> */}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {/* <AnimatePresence>
        {mobileMenuOpen && <NavbarMobileView />}
      </AnimatePresence> */}
    </nav>
  );
};

export default Navbar;
